import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { WorkspaceStatus } from '@workspaces/models/agent';
import { WorkspaceAgentService } from '@workspaces/services/agent.service';

@Injectable()
export class MockWorkspaceAgentService extends WorkspaceAgentService implements WorkspaceAgentService {
  public override getAgentRunStatus(workspaceId: string): Observable<WorkspaceStatus> {
    return of({ status: 'COMPLETED', workspace_id: workspaceId } satisfies WorkspaceStatus).pipe(delay(500));
  }
}
